import React from 'react';
import "../styles/Navbar.css";

function Navbar() {
    return (
      <div className="card-header bg-dark text-white">
      Employee Directory
      </div>

    )

}

export default Navbar;